/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Povolený typ geometrie vrstvy.
 * @export
 * @enum {string}
 */

export const LayerGeometryType = {
    POINT: 'POINT',
    LINE: 'LINE',
    POLYGON: 'POLYGON'
} as const;

export type LayerGeometryType = typeof LayerGeometryType[keyof typeof LayerGeometryType];



